import qcardRoute from './qcard';
import error from './error';
import rewardCollection from './rewardCollection';

export default [qcardRoute, error, rewardCollection];
